import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import '../../styleLess/signature/management.scss'
import Unitmeasurement from './components/unitmeasurement.com'
import Holiday from './components/holiday.com'
import Company from './components/company.com'
import PowerBI from './components/powerBi.com'

import KPI from './components/kpi.com'
import Group from './components/group.com'
import Impact from './components/impact.com'
import Professional from './components/professional.com'
import Support from './components/support.com'
import Business from './components/business.com'
import BusinessUnit from './components/syncBusinessUnit.com'
import User from './components/user.com'
import Role from './components/role.com'
import Benefit from './components/benefit.com'
import { getCookie } from 'helper/cookie'
import { getResultCompany } from 'api/MasterData/company'
import { getPermissionControl } from 'api/Admin/rolePermission'
import lang from 'lang/en'
const ContainerManagement = styled.div``
const Head = styled.div``
const Body = styled.div``
const initalState = {
  data: [],
  isLoading: true,
}

import { CounterContext } from 'redux/Golbalvalues'
import { useHistory } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import AuthADFS from './components/authADFS.com'

const ManagementFunctional = () => {
  // const [title, setTitle] = useState('unitmeasurment')
  const [checkLanding, setCheckLanding] = useState(false)
  const [switchComponents, setSwitchComponents] = useState()
  const [title, setTitle] = useState()
  const infoUser = JSON.parse(getCookie('infoUser'))
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataCompany, setDataCompany] = useState(initalState.data)
  const urlPage = window.location.href
  const split = urlPage.split('/')
  const language = getCookie('lang')
  const word = lang[language]
  const [openDefaultTree, setOpenDefaultTree] = useState(true)
  let today = new Date().toISOString().slice(0, 10)
  let landing = ''
  landing = split[4]

  //checkrole
  const { mainRoleUser, adminPermission, setPathActive } = useContext(CounterContext)

  //url
  const history = useHistory()

  const roleUser = getCookie('roleUser')

  const Components_Choice = async () => {
    if (split[4]) {
      let datapermission = []
      let cango = false
      let admincanpass = false
      await getPermissionControl({
        token: token,
      })
        .then(async (response) => {
          const { status, data, error } = response
          if (error) {
            return true
          }
          if (status === 200) {
            if (data.result?.permission == null) {
              datapermission = []
            } else {
              datapermission = data.result.permission
            }
          } else {
            return true
          }
        })
        .catch((error) => {
          console.error(error)
        })

      if (roleUser == 1) {
        admincanpass = true
      }
      if (landing === 'unitmeasurement') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_unit' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('unitmeasurement')
          setTitle(word['Unit_Measurement'])
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'business') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_buss' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('business')
          setTitle('Business Group')
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'support') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_supp' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('support')
          setTitle(word['Support_Category'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'group') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_group' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('group')
          setTitle(
            word['Project_Group'] +
            '/' +
            word['Project_Category'] +
            '/' +
            word['Strategic_Imperative'],
          )
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'holiday') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_hol' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('holiday')
          setTitle(word['Holiday'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'kpi') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_kpi' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('kpi')
          setTitle(word['KPI_Finance_Type'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'professional') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_profsk' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('professional')
          setTitle(word['Professional_Skills'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'impact') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_impact' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('impact')
          setTitle(word['Impact_Type'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'company') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_com' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('company')
          setTitle('Business' + '/' + word['Operation'] + '/' + word['Sub_operation'])
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'user') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_user' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('user')
          setTitle(word['User_Management'])
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'powerbi') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_powbi' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('powerbi')
          setTitle('Power BI Report')
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'role') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_role' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('role')
          setTitle(word['Role_and_Permission'])
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'authADFS') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_adfs' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('authADFS')
          setTitle(word['Custom_Auth_ADFS'])
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'benefit') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_benefit' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('benefit')
          setTitle('Benefit Type')
        } else {
          history.push(`/no-permission`)
        }
      } else if (landing === 'business-unit') {
        datapermission?.map((item) => {
          item.menu_code == 'adm_sync_business' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('business-unit')
          setTitle('Business Unit')
          setOpenDefaultTree(true)
        } else {
          history.push(`/no-permission`)
        }
      } else {
        datapermission?.map((item) => {
          item.menu_code == 'adm_unit' ? (item.read == 'Y' ? (cango = true) : (cango = false)) : _
        })
        if (cango == true || admincanpass == true) {
          setSwitchComponents('unitmeasurement')
          setTitle(word['Unit_Measurement'])
        } else {
          history.push(`/no-permission`)
        }
      }

      setCheckLanding(true)
    } else {
      history.push(`/no-permission`)
    }
  }
  useEffect(() => {
    Components_Choice()
  }, [landing])

  const RenderBodyComponents = () => {
    switch (switchComponents) {
      case 'business':
        return (
          <Business
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'support':
        return (
          <Support
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'professional':
        return (
          <Professional
            infoUser={infoUser}
            today={today}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'impact':
        return (
          <Impact
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'group':
        return (
          <Group
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'kpi':
        return (
          <KPI
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'holiday':
        return (
          <Holiday
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'company':
        return (
          <Company
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'powerbi':
        return (
          <PowerBI
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'user':
        return <User today={today} />
      case 'role':
        return <Role />
      case 'authADFS':
        return (
          <AuthADFS
            infoUser={infoUser}
            today={today}
            dataCompany={dataCompany}
            openDefaultTree={openDefaultTree}
          />
        )
      case 'benefit':
        return <Benefit infoUser={infoUser} today={today} />
      case 'business-unit':
        return <BusinessUnit />
      default:
        return (
          <Unitmeasurement infoUser={infoUser} today={today} dataCompany={dataCompany} />
        )
    }
  }

  const getDataListCompany = async () => {
    await getResultCompany({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCompany(data)
          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      setPathActive('/management')
      getDataListCompany()
    }
  }, [token])

  return (
    <ContainerManagement>
      <Helmet>
        <title>AXONS PROJECT | Management</title>
      </Helmet>
      <Head className="management-header">
        <h4>{word['Admin_Management']}</h4>
        <h1 className="no-breadcrumb">{title}</h1>
      </Head>
      <Body className="management-body">{RenderBodyComponents()}</Body>
    </ContainerManagement>
  )
}
export default ManagementFunctional
